import Button from "../../components/Button"
import {IProjGridFilter, IProjGridQuery} from '../../helpers/Interfaces'

interface HomeProps {
    filterObj: IProjGridFilter;
    setFilterObj: Function;
    queryObj: IProjGridQuery;
    setQueryObj: Function;
}

export default function ProjFilterBlock(props: HomeProps) {

    const {filterObj, setFilterObj, queryObj, setQueryObj} = props

    function handleChange(value: string, name: string) {
        setFilterObj((prevState: any) => {
            return {...prevState, [name as keyof typeof prevState]: value.trimStart()}
        })
    }

    function handleClick(event: any) {
        window.history.replaceState(null, '', `/mapper/projects/1`)

        if (event.target.name === 'Search' || event.key === 'Enter') {
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })
        } else {
            for (let k in filterObj) {
                    filterObj[k as keyof typeof filterObj] = ''
            }
            setQueryObj((prevState: any) => {
                return {...prevState, filterObj: filterObj, currentPage: 1}
            })
        }
    }

    return (

        <div className="filter-base-container proj-grid-filter">

            <div className="proj-filter-items">

                <div className="proj-filter-oneblock">
                    <div className="field-label">Project type</div>
                    <select
                        name="projType"
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        // onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                        value={filterObj.projType}
                    >
                        <option value="all">all</option>
                        <option value="export">export</option>
                        <option value="import">import</option>
                    </select>
                </div>

                <div className="proj-filter-oneblock">
                    <div className="field-label">Project Name</div>
                    <input
                        name="projName"
                        type="text"
                        className="filter-input"
                        onChange={(event) => handleChange(event.target.value, event.target.name)}
                        onKeyDown={(event) => event.key === 'Enter' ? handleClick(event) : ''}
                        value={filterObj.projName}
                    />
                </div>


            </div>  {/* ITEMS END */}


            <div className="proj-filter-buttons">

                <div className="btn-container">
                    {/*<Button type="primary" text="Search" onclick={handleClick}/>*/}
                    <Button type="primary" text="Search" onclick={(event: any) => handleClick(event)}/>
                </div>

                <div className="btn-container">
                    <Button type="secondary" text="Clear" onclick={(event: any) => handleClick(event)}/>
                </div>

            </div>  {/* BUTTONS END */}


        </div>

    )
}
